import { getMomentDate } from '../utils/commonUtils';
import BaseModel from './BaseModel';
export default class GroupCategory extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.name = data.name || this.translate.name || undefined;
        this.parentId = data.parentId || undefined;
        this.parentName = data.parentName || this.translate.parentName || undefined;
        this.order = data.order || 0;
        this.createdDate = getMomentDate(data.createdDate);

        // attributes for TreeSelect Component
        this.setChildren(data.children || []);
        this.title = this.name;
        this.value = this.id;
        this.key = this.id;
    }

    setChildren(children = []) {
        this.children = (children || []).map(item => new GroupCategory(item));
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            name: this.name,
            parentId: this.parentId,
            order: this.order,
        })
        if(hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                categoryId: this.translate.categoryId || this.id,
                name: this.name,
                languageCode: this.languageCode,
            }
        }
        return result;
    }

}